export default __webpack_public_path__ + "static/media/ic-marker-invalid.4b49e0ad.svg";